import { cva } from 'class-variance-authority';

const page = cva('w-full', {
  variants: {
    pt: {
      standard: 'pt-10 lg:pt-20',
      step: 'pt-0 md:pt-10',
      none: 'pt-0',
      undefined: '',
    },
    pb: {
      none: 'pb-0',
      undefined: 'pb-10',
    },
  },
});

export default page;
